import { useMemo } from 'react';

import { EventTriggerType, Trigger } from '../../domain';
import { TriggerTextDetail } from './components/TriggerTextDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

export const XPostTriggerDetails = ({ trigger, triggerType }: Props) => {
  const postText = useMemo(() => {
    if (!trigger.signature) return '';
    const match = trigger.signature.match(/^x-verify-post-(.+)$/);
    return match ? match[1] : '';
  }, [trigger.signature]);

  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />

      {postText && <TriggerTextDetail label="Post Text" value={postText} />}
    </div>
  );
};
